import { render, staticRenderFns } from "./TeamDescription.vue?vue&type=template&id=2e0c4272&scoped=true&"
import script from "./TeamDescription.vue?vue&type=script&lang=js&"
export * from "./TeamDescription.vue?vue&type=script&lang=js&"
import style0 from "./TeamDescription.vue?vue&type=style&index=0&id=2e0c4272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0c4272",
  null
  
)

export default component.exports